import NotificationSettingsRecordUpdateItemDeal from "@app/types/notifications/NotificationSettingsRecordUpdateItemDeal";

const getRecordOwnershipDealLevelSettingsState = (
  enabled: boolean
): NotificationSettingsRecordUpdateItemDeal => ({
  closedLost: enabled,
  closedWon: enabled,
  enabled,
  openStage: enabled,
});

export default getRecordOwnershipDealLevelSettingsState;
